import { render, staticRenderFns } from "./secondTab.vue?vue&type=template&id=c20343b8&scoped=true&"
import script from "./secondTab.vue?vue&type=script&lang=js&"
export * from "./secondTab.vue?vue&type=script&lang=js&"
import style0 from "./secondTab.vue?vue&type=style&index=0&id=c20343b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20343b8",
  null
  
)

export default component.exports